<template>
  <component :is="dynamicComponent" />
</template>

<script setup>
import { useExperiments } from '@composables/useExperiments';
import ProductDetails from './ProductDetails';
import ProductDetaillsTreatment2 from './experiment_2145_22/ProductDetaills';

const {
  experimentFlags: { productDetailsTreatment2 },
} = useExperiments();

const dynamicComponent = productDetailsTreatment2 ? ProductDetaillsTreatment2 : ProductDetails;

</script>
